import { useMemo } from 'react';
import { ModelConfiguratorSortingField } from '../../../api/types';
import makeGetSortingRule from '../../../utilities/makeGetSortingRule';

export const getSortField = makeGetSortingRule((field): ModelConfiguratorSortingField => {
    switch (field) {
        case 'module.company.displayName':
            return ModelConfiguratorSortingField.Company;

        case 'displayName':
            return ModelConfiguratorSortingField.DisplayName;

        case 'variantConfiguratorIds':
            return ModelConfiguratorSortingField.VariantConfiguratorCount;

        case 'module.displayName':
            return ModelConfiguratorSortingField.ConfiguratorModuleDisplayName;

        case 'vehicleModule.displayName':
            return ModelConfiguratorSortingField.VehicleModuleDisplayName;

        default:
            throw new Error('Unknown Sorting Field!');
    }
});

const useSortOrder = sort => {
    const companySort = useMemo(
        () => (sort.field === ModelConfiguratorSortingField.Company ? sort.orderValue : undefined),
        [sort]
    );

    const displayNameSort = useMemo(
        () => (sort.field === ModelConfiguratorSortingField.DisplayName ? sort.orderValue : undefined),
        [sort]
    );

    const variantConfiguratorCountSort = useMemo(
        () => (sort.field === ModelConfiguratorSortingField.VariantConfiguratorCount ? sort.orderValue : undefined),
        [sort]
    );

    const configuratorModuleDisplayNameSort = useMemo(
        () =>
            sort.field === ModelConfiguratorSortingField.ConfiguratorModuleDisplayName ? sort.orderValue : undefined,
        [sort]
    );

    const vehicleModuleDisplayNameSort = useMemo(
        () => (sort.field === ModelConfiguratorSortingField.VehicleModuleDisplayName ? sort.orderValue : undefined),
        [sort]
    );

    return {
        companySort,
        displayNameSort,
        variantConfiguratorCountSort,
        configuratorModuleDisplayNameSort,
        vehicleModuleDisplayNameSort,
    };
};

export default useSortOrder;
